'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
export const ResignModal = () => {
  const $ = _c(6);
  const [isModalOpened, setIsModalOpened] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsModalOpened(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeModal = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 typo-h6">회원탈퇴</h2>;
    t2 = <p className="font-400 text-Gray-700 typo-body4">WELLO INC.</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="align-center flex flex-col gap-8 pb-16 text-Gray-900">{t1}{t2}<p className="font-400 typo-body3">로그인 후 회원탈퇴 페이지로 이동해요.<br />탈퇴후 회원님의 모든 정보는 즉시 삭제해요.</p><Button onClick={closeModal}>확인했어요</Button></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isModalOpened) {
    t4 = <ResponsiveDialog opened={isModalOpened} onClose={closeModal} drawerType="bottom">{t3}</ResponsiveDialog>;
    $[4] = isModalOpened;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};